module.exports = __webpack_public_path__ + "fi.41fd00fba0356314e125.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/fi.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/fi.svg
// module chunks = styles